import { Reducer } from "redux";

import {
    FEED_UNTRUSTWORTHY_USER_FETCH_FAILURE,
    FEED_UNTRUSTWORTHY_USER_FETCH_REQUEST,
    FEED_UNTRUSTWORTHY_USER_FETCH_SUCCESS,
    FeedUntrustworthyUserFetchFailureAction,
    FeedUntrustworthyUserFetchRequestAction,
    FeedUntrustworthyUserFetchSuccessAction,
} from "@/mk2/apps/forum/containers/FeedUntrustworthyUser/FeedUntrustworthyUser.actions";
import infiniteList, {
    State as InfiniteListState,
    initialState as initialInfiniteListState,
} from "@/mk2/reducers/infiniteList";

export interface FeedState extends InfiniteListState {
    user: number;
}

export const initialFeedState = {
    ...initialInfiniteListState,
    user: null,
};

export interface State {
    [username: string]: FeedState;
}

export const initialState: State = {};

const feedOneUntrustworthyUserReducer = infiniteList<
    FeedUntrustworthyUserFetchRequestAction,
    FeedUntrustworthyUserFetchSuccessAction,
    FeedUntrustworthyUserFetchFailureAction
>("FEED_UNTRUSTWORTHY_USER_FETCH", (a) => a.response.result.comments);

type FeedUntrustworthyUserActions =
    | FeedUntrustworthyUserFetchRequestAction
    | FeedUntrustworthyUserFetchSuccessAction
    | FeedUntrustworthyUserFetchFailureAction;

const feedUntrustworthyUserReducer: Reducer<State> = (
    state = {},
    action: FeedUntrustworthyUserActions,
) => {
    switch (action.type) {
        case FEED_UNTRUSTWORTHY_USER_FETCH_FAILURE:
        case FEED_UNTRUSTWORTHY_USER_FETCH_REQUEST:
            return {
                ...state,
                [action.username]: {
                    ...state[action.username],
                    ...feedOneUntrustworthyUserReducer(state[action.username], action),
                },
            };
        case FEED_UNTRUSTWORTHY_USER_FETCH_SUCCESS:
            return {
                ...state,
                [action.username]: {
                    ...state[action.username],
                    ...feedOneUntrustworthyUserReducer(state[action.username], action),
                    user: action.response.result.user,
                },
            };
        default:
            return state;
    }
};

export default feedUntrustworthyUserReducer;
